// extracted by mini-css-extract-plugin
export var cancelButton = "search-input-module--cancelButton--e1f45";
export var cancelIcon = "search-input-module--cancelIcon--8e3f8";
export var filterSearch = "search-input-module--filterSearch--04a85";
export var input = "search-input-module--input--e0657";
export var searchIcon = "search-input-module--searchIcon--da02a";